import { Field, Form, useFormikContext } from 'formik';
import { Button } from 'primereact/button';
import React from 'react';
import { FormikCalendar } from '../../../../components/prime-formik';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  submitButton: {
    id: 'account.super-matches.contact-request-dialog.submit-button',
    defaultMessage: 'Request contact',
  },
});

const SuperMatchContactRequestForm = () => {
  const { formatMessage } = useIntl();
  const { setFieldValue } = useFormikContext();

  return (
    <Form>
      <Field
        name="contactRequestDeadline"
        id="contactRequestDeadline"
        component={FormikCalendar}
        minDate={new Date()}
        dateFormat="yy-M-dd"
        setFieldValue={(fieldName, selectedValue) => {
          setFieldValue(fieldName, selectedValue, false);
        }}
      />
      <div className="mt20">
        <Button type="submit" label={formatMessage(messages.submitButton)} />
      </div>
    </Form>
  );
};

export default SuperMatchContactRequestForm;
